import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  sendPasswordResetEmail,
} from "firebase/auth";
import { auth } from "../firebase/config";

/**
 * Admin accounts are created manually in the Firebase Console
 * (Authentication -> Users -> Add user). There is deliberately no
 * public sign-up flow here — this is a single-business admin panel,
 * not a multi-tenant app.
 */
export function login(email, password) {
  return signInWithEmailAndPassword(auth, email, password);
}

export function logout() {
  return signOut(auth);
}

export function subscribeToAuth(callback) {
  return onAuthStateChanged(auth, callback);
}

/**
 * Sends a password reset email via Firebase Auth. Firebase handles
 * the actual reset page/flow — this just triggers the email.
 */
export function resetPassword(email) {
  return sendPasswordResetEmail(auth, email);
}
